export default "__VITE_ASSET__BSLJ1rlt__"